module.exports = __webpack_public_path__ + "img/horizontal_2_1_8011.bb6bc11f.png";